import {
  parseRuntimeConfig,
  type RuntimeConfig,
} from "@/config/runtime-config-schema";

export async function loadRuntimeConfig(): Promise<Readonly<RuntimeConfig>> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 10_000);
  try {
    const response = await fetch("/runtime-config.json", {
      cache: "no-store",
      signal: controller.signal,
      credentials: "same-origin",
    });
    if (!response.ok) {
      throw new Error("Runtime configuration request failed");
    }
    const contentType = response.headers
      .get("content-type")
      ?.split(";")[0]
      .trim()
      .toLowerCase();
    if (contentType !== "application/json") {
      throw new Error("Runtime configuration is not JSON");
    }
    return parseRuntimeConfig(await response.json());
  } catch {
    throw new Error("Unable to load valid runtime configuration");
  } finally {
    clearTimeout(timer);
  }
}
